/**
 * Component Registry for Corporate Multidomain Theme
 *
 * Provides both standard property-level components and
 * corporate-level components (listings, navigation, breadcrumbs).
 */

import type { ComponentRegistry } from '@vibesites/runtime';

// TODO: Import corporate components as they are built
// import { CorporateHero } from './components/CorporateHero';
// import { PropertyListing } from './components/PropertyListing';
// import { StateListing } from './components/StateListing';
// import { CityListing } from './components/CityListing';
// import { Breadcrumbs } from './components/Breadcrumbs';
// import { CorporateNav } from './components/CorporateNav';

export const registry: ComponentRegistry = {
  // Standard property-level slots will be inherited from parent
  // Corporate-level slots will be added here
  Header: null,
  Footer: null,
  Hero: null,
  PageHero: null,
  Gallery: null,
  FloorplansList: null,
  AmenitiesList: null,
  NeighborhoodMap: null,
  ContactForm: null,
  OfficeHours: null,
  Navigation: null,
  MobileDrawer: null,
  VirtualTourEmbed: null,
  Reviews: null,
  SpecialOffers: null,
  PetPolicy: null,
  Fees: null,
  PropertyOverview: null,
  SocialHub: null,
  CTAButton: null,
  CTASection: null,
  Spacer: null,
  Divider: null,
  RichText: null,
};

export default registry;
